import {Environment} from './environment';

export const publicPortByEnvironment: Record<
  Environment,
  Record<'desktop' | 'mobile', number | undefined>
> = {
  production: {desktop: undefined, mobile: undefined},
  preview: {desktop: undefined, mobile: undefined},
  staging: {desktop: undefined, mobile: undefined},
  development: {desktop: 7777, mobile: 8888},
};
